import classNames from "classnames";
import { ReactComponent as LoaderIcon } from "../../assets/ic-loader.svg";

const Loader = ({ className, loaderIconClassName = "yellow-accent-color" }) => (
  <div className={classNames(className)}>
    <LoaderIcon className={classNames(loaderIconClassName, "spinning")} />
  </div>
);

export default Loader;
